import {isValueEmpty} from '@/utils';
import moment from 'moment';

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  if (isValueEmpty(num)) {
    return '';
  }
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
}

/**
 * "2021-05-12T08:16:40.400Z" => "2021/05/12 16:16:40"
 * @param {string} time
 */
export function toTimeFormatFilter(time) {
  if (time === null || time === undefined || time === '') {
    return '';
  }
  return moment.utc(time).local().format('YYYY/MM/DD HH:mm:ss');
}

/**
 * "2021-05-12T08:16:40.400Z" => "2021/05/12"
 * @param {string} time
 */
export function toDateFormatFilter(time) {
  if (time === null || time === undefined || time === '') {
    return '';
  }
  return moment.utc(time).local().format('YYYY/MM/DD');
}
